
import angular from 'angular';

const controllerInfo = {
    module: 'ib-web-ancillaries-module',
    inject: ['$timeout', '$scope'],
    required: []
};


export class CollapseAncillariesDetailsController implements ng.IController {
    public isCollapsed = true;
    public text = '';
    public closedText = '';
    public openedText = '';
    public init = true;

    constructor (
        private $timeout: ng.ITimeoutService,
        private $scope: angular.IScope
    ) {
        this.$scope.$on('updateCollapseText', this.externalChangeText);
        this.$scope.$on('initSeatCollapse', this.initSeatCollapse);
        this.$scope.$on('closeLeyendCollapse', this.closeLeyendCollapse);
    }

    /**
    * Close collapse when receive event
    */
    closeLeyendCollapse = (): void => {
        this.isCollapsed = false;
        this.init = false;
    };

    toggle = (): void => {
        this.isCollapsed = !this.isCollapsed;
        this.text = this.isCollapsed ? this.openedText : this.closedText;
        this.init = false;
    };

    initSeatCollapse = (): void => {
        this.init = true;
        this.isCollapsed = true;
    };

    initCollapse = (closedText: any, openedText: any): void => {
        this.closedText = closedText;
        this.text = closedText;
        this.openedText = openedText;
    };

    externalChangeText = (evt, text): void => {
        this.text = !this.isCollapsed ? text : this.text;
        this.closedText = text;
    };

    closeContent = (): void => {
        if (this.init) {
            this.$scope.$emit('closeContent');
        }
    };


    externalToggle=(event):void=> {
        const $element:any = this.findBaggagesCollapseElement(event);
        if ($element !== null) {
            this.$timeout(() => {
                angular.element($element.querySelector('.fc-collapse__more-details'))[0].click();
            });
        }
    };


    findBaggagesCollapseElement=(event:any):void=> {
        let $element = event.target.parentNode;
        let parentFound = false;
        let element, compiled;
        while ($element && !parentFound) {
            $element.className = $element.className || '';
            parentFound = $element.className.indexOf('fc_ibe-baggages_item-wrapper') !== -1;
            if (!parentFound) {
                $element = $element.parentNode;
            }
        }
        return parentFound ? $element : null;
    };

}


try {
    CollapseAncillariesDetailsController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(CollapseAncillariesDetailsController.name, CollapseAncillariesDetailsController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    CollapseAncillariesDetailsController.$inject = controllerInfo.inject;
    mod.controller(CollapseAncillariesDetailsController.name, CollapseAncillariesDetailsController);
}